module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-beurre-de-cacao.f19d05ed.jpg";